export type PageHistoryState = {
    forward: boolean;
};

export const initialPageHistoryState = {
    forward: true
};
